import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/bot-pilot`;
const config = { withCredentials: true, timeout: 110000 };

export const usePilot = () => {
  const [data, setData] = useState(null), [error, setError] = useState('');
  const [loading, setLoading] = useState(true), [busy, setBusy] = useState('');
  const [now, setNow] = useState(Date.now());
  const alive = useRef(true), writing = useRef(false), sequence = useRef(0);
  const load = useCallback(async () => {
    const turn = ++sequence.current;
    setLoading(true);
    try {
      const response = await axios.get(API, config);
      if (!alive.current || turn !== sequence.current) return;
      setData(response.data);
    } catch (failure) {
      if (alive.current && turn === sequence.current) { setData(null); setError(failure.response?.data?.detail || 'pilot_service_unavailable'); }
    } finally { if (alive.current && turn === sequence.current) setLoading(false); }
  }, []);
  useEffect(() => {
    alive.current = true; load();
    const clock = setInterval(() => setNow(Date.now()), 1000);
    return () => { alive.current = false; ++sequence.current; clearInterval(clock); };
  }, [load]);
  const post = async (path, body = {}) => {
    if (writing.current) return false;
    writing.current = true; ++sequence.current; setBusy(path); setError('');
    try {
      await axios.post(API+path, body, config);
      if (alive.current) await load();
      return true;
    } catch (failure) {
      if (alive.current) {
        setError(failure.response?.data?.detail || 'pilot_service_unavailable');
        await load();
      }
      return false;
    } finally { writing.current = false; if (alive.current) setBusy(''); }
  };
  return { data, error, loading, busy, now, post, refresh: () => { if (!writing.current) { setError(''); load(); } } };
};